import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function ReactionPill({ reaction, onToggle }) {
    const { emoji, count, mine } = reaction;
    const base = {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
        height: '26px',
        padding: '0 8px',
        borderRadius: 'var(--radius-pill)',
        border: mine ? '1.5px solid var(--color-accent)' : '1.5px solid transparent',
        background: mine ? 'var(--color-accent-muted)' : 'var(--color-surface-hover)',
        color: 'var(--color-text)',
        fontSize: 'var(--font-sm)',
        cursor: 'pointer',
        lineHeight: '1',
    };
    return (_jsxs("button", { type: "button", "data-reaction": "", "data-mine": mine ? '' : undefined, "aria-pressed": mine, "aria-label": `Реакция ${emoji}, ${count}`, style: base, onClick: () => onToggle(emoji), children: [_jsx("span", { "aria-hidden": "true", children: emoji }), _jsx("span", { "data-reaction-count": "", children: count })] }));
}
//# sourceMappingURL=ReactionPill.js.map